import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Nav, Badge, Spinner } from 'react-bootstrap';
import style from './style.module.scss';
import ReactTooltip from "react-tooltip";
import './style.css';

const NavAnalista = ({
  countFunds,
  countClaim,
  countPlan,
  countExecution,
  countStatus,
  countReceipt,
  loading
}) => {
  const [i, setI] = useState(0);

  useEffect(() => {
    setI(Math.floor(Math.random() * 6));
  }, [])

  const { t } = useTranslation();

  const getColor = (key) => {
    return [
      '#8A030C',
      '#048DD6',
      '#D6B02F',
      '#0A5D8A',
      '#D61A26',
      '#038A70'
    ][key];
  }

  const getValues = (v) => {
    return v.map((a, k) => {
      return (
        <Col className="p-1 mt-3" >
          <Card className="shadow bg-white rounded">
            <Card.Body className="nav-card p-3">
              <div className="nav-card-img" style={{ backgroundColor: getColor((k + i) % 6), borderColor: getColor((k + i) % 6) }}>
                {a.img ? a.img : ''}
              </div>
              <div className="nav-card-name">{a.name}</div>
              <div className="nav-card-value">
                {!loading ? a.value : (<>
                  <Spinner animation="border" style={{ color: '#e05c17' }}  />
                </>)}
              </div>
              <div className="nav-card-more-info" data-tip data-for={a.name}><i className="fas fa-question-circle"></i></div>
              <ReactTooltip id={a.name} place="right" effect="solid">
                {a.moreInfo ? a.moreInfo : ''}
              </ReactTooltip>
            </Card.Body>
          </Card>
        </Col>
      );
    })
  };
  return (
    <>
      <Row>
        <Col className="p-2 pl-4 pr-4">
          <Row className="justify-content-center">
            {getValues([
              { name: t('label:real value'), value: countFunds, img: <img className="img-nav" src="/calculator.png" />, moreInfo: 'Verbas cadastradas mas com valor real pendente.' },
              { name: t('label:plan'), value: countPlan, img: <img className="img-nav" src="/plan.png" />, moreInfo: 'Planos que estão pendentes de criação para o período atual ou estão em Draft.' },
              { name: t('label:execution'), value: countExecution, img: <img className="img-nav" src="/process.png" />, moreInfo: 'Ações que estão em execução.' },
              { name: t('label:evidence'), value: countStatus, img: <img className="img-nav" src="/finance.png" />, moreInfo: 'Ações que estão aguardando comprovações.' },
              { name: t('label:claim'), value: countClaim, img: <img className="img-nav" src="/decrease.png" />, moreInfo: 'Ações que estao aguardando recebimento de reembolso.' },
              { name: t('label:received'), value: countReceipt, img: <img className="img-nav" src="/received.png" />, moreInfo: 'Ações que tiverem reembolso recebido e estão concluídas.' }
            ])}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default NavAnalista;
